export const IMAGES = {
  cheesecake:
    'https://cdn.magicpatterns.com/uploads/1Pvfe4ZmN7XBVTRYPgu2qA/IMG_6714.jpg',
  box: 'https://cdn.magicpatterns.com/uploads/nh3sewArnm9pjmq89DqJdp/IMG_6715.jpg',
  heroFeature:
    'https://cdn.magicpatterns.com/uploads/1imJt9KyAdMz8ygVGDcPch/IMG_6721.png',

  // Aliases
  hero: 'https://cdn.magicpatterns.com/uploads/1imJt9KyAdMz8ygVGDcPch/IMG_6721.png',
  sensory:
    'https://cdn.magicpatterns.com/uploads/nh3sewArnm9pjmq89DqJdp/IMG_6715.jpg',
  ig1: 'https://cdn.magicpatterns.com/uploads/1Pvfe4ZmN7XBVTRYPgu2qA/IMG_6714.jpg',
  ig2: 'https://cdn.magicpatterns.com/uploads/nh3sewArnm9pjmq89DqJdp/IMG_6715.jpg',
  ig3: 'https://cdn.magicpatterns.com/uploads/1imJt9KyAdMz8ygVGDcPch/IMG_6721.png',
}
